module.exports = __webpack_public_path__ + "img/bg_red_popular.ea01e222.png";